import { useState, useEffect } from 'react';
import { Grid, Box, Button, TextField, Typography, Paper, Breadcrumbs } from '@mui/material';
import PrivateLayout from '../../layouts/privateLayout';
import { ApiClientProvider, useApiClient } from '../../context/ApiClientContext';
import ComponentBackdrop from '../../components/backdrop';
import toast from 'react-hot-toast'; // ✅ assuming you use react-hot-toast
import api from "../../helper/baseApi";
import BasicBreadcrumbs from '../../components/breadcrumb';

const GlobalSetting = () => {
    const { apiUrls: { mobileApiUrl } } = useApiClient();
    const [poisumName, setPoisumName] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState(false);

    const teamIdentity = localStorage.getItem('poisumName');

    const handleSave = async () => {
        if (!poisumName.trim()) {
            toast.error("Please enter your Team Identity before saving.");
            return;
        }

        setIsSaving(true);
        setOpenBackdrop(true);

        try {
            const apiUrl = `${mobileApiUrl}onboarding/update-email-greeting`
            const response = await api.put(apiUrl,
                { emailGreeting: poisumName }
            );
            console.log(response);
            if (response.status === 200) {

                setTimeout(() => {
                    localStorage.setItem("poisumName", poisumName);

                    setIsSaving(false);
                    setOpenBackdrop(false);
                    toast.success("Successfully set your team identity");
                    setPoisumName('');
                    // window.location.reload();

                }, 2000);

                
                

            }
        } catch (error) {
            toast.error("Failed to save. Please try again.");
        } finally {
            
        }
    };

    return (
        <PrivateLayout>
            <ComponentBackdrop openBackdrop={openBackdrop} />

            <Box sx={{ mx: "40px", mt: 5 }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "flex-start", sm: "center" },
                        gap: 2,
                        mb: 3,
                    }}
                >

                    <BasicBreadcrumbs first="Global Setting" />

                </Box>
                <Box sx={{ mt: 2 }}>
                    <Paper
                        elevation={8}
                        sx={{
                            p: 4,
                            borderRadius: 3,
                            backgroundColor: 'background.main',
                            border: '1px solid #e0e0e0',
                            width: '100%',
                            minHeight: '30vh',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative',
                        }}
                    >
                        {/* Content Section */}
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle" color="text.secondary" sx={{ mb: 1 }}>
                                <strong>Team Identity</strong>
                            </Typography>

                            {teamIdentity && (
                                <Typography
                                    variant="body"
                                    color="text.secondary"
                                    sx={{ mb: 1, mt: 1 }}
                                >
                                    Your team now is <strong>{teamIdentity}</strong>, a unique name
                                    that represents your culture and spirit in POISUM.
                                </Typography>
                            )}

                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                placeholder="Enter your Team Identity"
                                value={poisumName}
                                onChange={(e) => setPoisumName(e.target.value)}
                                sx={{ mt: 1 }}
                            />
                            <Typography variant="note" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
                                This name will be used in email greetings and other communications to
                                reflect your team's identity.
                            </Typography>
                        </Box>

                        {/* Save Button */}
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: 20,
                                right: 20,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSave}
                                disabled={isSaving}
                            >
                                {isSaving ? 'Saving...' : 'Save'}
                            </Button>
                        </Box>
                    </Paper>
                </Box>
            </Box>
        </PrivateLayout>
    );
};

export default GlobalSetting;
